var map = {
	"./decidim/avatar-multiuser.png": 70566,
	"./decidim/brands/facebook.svg": 69168,
	"./decidim/brands/google.svg": 62825,
	"./decidim/brands/twitter-x.svg": 41090,
	"./decidim/cc-badge.png": 41880,
	"./decidim/decidim-logo.svg": 29476,
	"./decidim/default-avatar.svg": 26428,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 25640,
	"./decidim/icons.svg": 35735,
	"./decidim/pattern.png": 15448,
	"./decidim/placeholder-card-g.svg": 80893,
	"./decidim/placeholder-card-l.svg": 29206,
	"./decidim/placeholder.jpg": 28469,
	"./decidim/remixicon.symbol.svg": 87001,
	"./decidim/vendor/social-share-button/douban.svg": 48312,
	"./decidim/vendor/social-share-button/email.svg": 86645,
	"./decidim/vendor/social-share-button/facebook.svg": 90763,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 32517,
	"./decidim/vendor/social-share-button/hacker_news.svg": 79557,
	"./decidim/vendor/social-share-button/linkedin.svg": 33933,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 41470,
	"./decidim/vendor/social-share-button/pinterest.svg": 38635,
	"./decidim/vendor/social-share-button/reddit.svg": 64927,
	"./decidim/vendor/social-share-button/telegram.svg": 15858,
	"./decidim/vendor/social-share-button/tumblr.svg": 64990,
	"./decidim/vendor/social-share-button/twitter.svg": 56932,
	"./decidim/vendor/social-share-button/vkontakte.svg": 38682,
	"./decidim/vendor/social-share-button/wechat.svg": 8901,
	"./decidim/vendor/social-share-button/whatsapp.svg": 40309,
	"./decidim/vendor/social-share-button/x.svg": 97013,
	"./decidim/vendor/social-share-button/xing.svg": 92523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43505;